export default function dividerWidget(editor) {
  editor.DomComponents.addType('eb-divider', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-divider'
    },
    model: {
      defaults: {
        name: 'Divider',
        tagName: 'hr',
        void: true,
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-divider' },
        style: {
          'border': 'none',
          'border-top': '2px solid #e0e0e0',
          'margin': '20px 0',
          'width': '100%',
        },
        traits: [
          {
            type: 'select', name: 'data-style', label: 'Style',
            options: [
              { id: 'solid', label: 'Solid' },
              { id: 'dashed', label: 'Dashed' },
              { id: 'dotted', label: 'Dotted' },
              { id: 'double', label: 'Double' },
            ],
            changeProp: true,
          },
        ],
      },
      init() {
        this.on('change:attributes:data-style', this.updateBorderStyle)
      },
      updateBorderStyle() {
        const style = this.getAttributes()['data-style'] || 'solid'
        this.addStyle({ 'border-top-style': style })
      },
    },
  })

  editor.BlockManager.add('eb-divider', {
    label: 'Divider',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M2 12h20v1H2z"/></svg>',
    content: { type: 'eb-divider' },
  })
}
